import {Injectable} from '@angular/core';
import {UnrAd} from '../core/api/resources/ad.resource';
import {Step} from '../core/api/resources/step.resource';

@Injectable({
  providedIn: 'root'
})
export class UnrAdsService {

  private adList: UnrAd[] = [];
  set ads(value: UnrAd[]) {
    console.log(value);
    this.adList = value;
  }
  get ads(): UnrAd[] {
    return this.adList;
  }




  isFirstStep(step: Step, stepList: Step[]): boolean {
    return stepList.findIndex(stepItem => stepItem.id === step.id) === 0;
  }
}
